export default __webpack_public_path__ + "static/media/table4seatDiagonal.9ae2b66e.svg";